import React, { memo, useState } from "react";

import { IEditAdvancedRemarksBaseProps, IEditAdvancedRemarksProps } from "components/prime-data-table/interfaces/edit-interfaces";
import { useAdvancedRemarks } from "components/prime-data-table/advancedRemarksContext/context";
import { hasRemarks } from "utils/hasRemarks";

const arePropsEqual = (prev, next) => {
    return prev.hasRemarks == next.hasRemarks && prev.rowId == next.rowId;
};

export const AdvancedRemarks = (props: IEditAdvancedRemarksProps) => {
    const { setModalOpen, setModalData } = useAdvancedRemarks();

    return <AdvancedRemarksBase setModalData={setModalData} setModalOpen={setModalOpen} {...props} />;
};

const AdvancedRemarksBase = memo((props: IEditAdvancedRemarksBaseProps) => {
    const { setModalData, setModalOpen, rowId, hasRemarks: hasRemarksProp } = props;

    const handleOpen = () => {
        setModalData({
            rowId: rowId,
            addFromLookupProps: props.addFromLookupProps,
            readonly: true,
        });
        setModalOpen(true);
    };

    return (
        <div className="advanced-remark">
            <span onClick={handleOpen} className={hasRemarks(hasRemarksProp)} />
        </div>
    );
}, arePropsEqual);
